export const ADRESS_REQUEST = 'ADRESS_REQUEST';
export const ADRESS_SUCCESS = 'ADRESS_SUCCESS';
export const ADRESS_ERROR = 'ADRESS_ERROR ';
